import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreIncubationRoutingModule } from './pre-incubation-routing.module';
import { ApplicationDashboardComponent } from './components/application-dashboard/application-dashboard.component';
import { HostInstitutionComponent } from './components/host-institution/host-institution.component';
import { PointOfContactComponent } from './components/point-of-contact/point-of-contact.component';
import { TrackRecordComponent } from './components/track-record/track-record.component';
import { InfrastructureComponent } from './components/infrastructure/infrastructure.component';
import { IntentForEoiComponent } from './components/intent-for-eoi/intent-for-eoi.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { IonicModule } from '@ionic/angular';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap';
import { DeclarationModalComponent } from './components/declaration-modal/declaration-modal.component';
import { PreincubatorRejectComponent } from './components/preincubator-reject/preincubator-reject.component';
import { HistoryDetailsComponent } from './components/history-details/history-details.component';
import { ApprovalModalComponent } from './components/approval-modal/approval-modal.component';
import { RemarksComponent } from './components/history-details/remarks/remarks.component';


@NgModule({
  declarations: [ApplicationDashboardComponent, HostInstitutionComponent, PointOfContactComponent, TrackRecordComponent, InfrastructureComponent, IntentForEoiComponent, DeclarationModalComponent, PreincubatorRejectComponent, HistoryDetailsComponent, ApprovalModalComponent, RemarksComponent],
  imports: [
    CommonModule,
    PreIncubationRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    NgxMaterialTimepickerModule,   
    IonicModule.forRoot(),
    DatepickerModule,
    BsDatepickerModule.forRoot(),
  ]
})
export class PreIncubationModule { }
